import React, {useEffect, useState} from "react";
import styles from "./saleTypesSettingsRow.module.scss";
import {DefaultSaleTypeDto, SaleTypeDto} from "../../../../../../../dtos";
import {Box, Checkbox, Typography} from "@mui/material";


interface Props {
    saleType: SaleTypeDto;
    defaultSaleType?: DefaultSaleTypeDto;
    isSelected: boolean;
    onChangeSelectionForSaleType: (saleType: SaleTypeDto, isSelected: boolean) => void;
}


export const SaleTypeSettingsRow: React.FC<Props> = ({
                                                         saleType,
                                                         defaultSaleType,
                                                         isSelected,
                                                         onChangeSelectionForSaleType
                                                     }) => {
    const [requisiteValue, setRequisiteValue] = useState<string>('');
    const [benefitValue, setBenefitValue] = useState<string>('');

    const [isSelectedSaleType, setSelectedSaleType] = useState<boolean>(false);

    useEffect(() => {
        setRequisiteValue(saleType.requisite ? saleType.requisite : defaultSaleType?.saleTypeData.defaultRequisite);
        setBenefitValue(saleType.benefit ? saleType.benefit : defaultSaleType?.saleTypeData.defaultBenefit);

    }, []);

    useEffect(() => {
        setSelectedSaleType(isSelected);
    }, [isSelected])


    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChangeSelectionForSaleType(saleType, e.target.checked);
    }
    return (
        <tr className={`${styles.sale_type_row} ${isSelectedSaleType ? styles.selected_row : ''}`}>
            <td>
                <Box sx={{
                    display: `flex`,
                    justifyContent: `center`,
                    alignItems: `center`
                }}>
                    <Checkbox checked={isSelected} onChange={onChange} disableRipple disableTouchRipple/>
                </Box>
            </td>
            <td>
                <div className={`${styles.content_cell_wrapper} ${
                    (defaultSaleType?.saleTypeData.defaultRequisite !== Number(requisiteValue) ||
                        defaultSaleType?.saleTypeData.defaultBenefit !== Number(benefitValue))
                        ? styles.disabledSaleTypeIcon
                        : ''}`}>
                    <img src={defaultSaleType?.saleTypeData.imageSrc} alt=""/>
                </div>
            </td>
            <td>
                <div className={styles.content_cell_wrapper} style={{textAlign: `center`}}>
                    {saleType.satCode}
                </div>
            </td>
            <td>
                <div className={styles.content_cell_wrapper}>
                    {saleType.satCaption}
                </div>
            </td>
            <td>
                {
                    saleType.satCode !== 1 && <div className={styles.content_cell_wrapper}>
                        <div className={styles.caption_for_requisite_benefit}>
                            {defaultSaleType?.saleTypeData.nameRequisite}
                        </div>
                        <Box>
                            <Typography>
                                {requisiteValue}
                            </Typography>
                        </Box>
                    </div>

                }
            </td>
            <td>
                {
                    saleType.satCode !== 1 && <div className={styles.content_cell_wrapper}>
                        <div className={styles.caption_for_requisite_benefit}>
                            {defaultSaleType?.saleTypeData.nameBenefit}
                        </div>
                        <Box>
                            <Typography>
                                {benefitValue}
                            </Typography>
                        </Box>
                    </div>

                }
            </td>

        </tr>
    )

}